/**
 * Paginates complete leagues, keeping every component row with its league.
 *
 * @param groups - Leagues already sorted for the matrix.
 * @param page - Requested one-based page number.
 * @param pageSize - Number of leagues per page; must be greater than zero.
 * @returns The clamped page, visible leagues, and total league count.
 */
export const paginateLeagues = <T>(groups: T[], page: number, pageSize: number) => {
  const lastPage = Math.max(1, Math.ceil(groups.length / pageSize));
  const validPage = Math.max(1, Math.min(page, lastPage));

  return {
    page: validPage,
    groups: groups.slice((validPage - 1) * pageSize, validPage * pageSize),
    total: groups.length,
  };
};
